import React from 'react';
import Checkbox from 'material-ui/Checkbox';

/**
 * A `BooleanSearchField` renders a material-ui Checkbox for a boolean
 * search field such as "Coach Me" or "Has Comments"
 */
export default class BooleanSearchField extends React.Component {
  onCheckboxChange = () => {
    this.props.onCheckboxChange(this.props.searchField, this._checkbox.isChecked());
  };

  render() {
    return (
      <Checkbox
        label={this.props.searchField.name}
        className="search-widget"
        defaultChecked={false}
        onCheck={this.onCheckboxChange}
        checked={this.props.checked}
        ref={c => (this._checkbox = c)}
      />
    );
  }
}
